import { render } from "./PagarView.vue?vue&type=template&id=478991c0"
import script from "./PagarView.vue?vue&type=script&lang=js"
export * from "./PagarView.vue?vue&type=script&lang=js"

import "./PagarView.vue?vue&type=style&index=0&id=478991c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__